export const MuiFormLabel = {
  styleOverrides: {
    root: {
      fontSize:"1.6rem",
    },
  },
}
